import { collection, addDoc, getFirestore, Timestamp } from 'firebase/firestore';
import { firebaseApp } from './firebaseConfig';

const db = getFirestore(firebaseApp);

const LOG_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 1 week — matches the Firestore TTL policy on `expiresAt`

/**
 * Writes a debug log entry for an in-app-purchase attempt to Firestore, so purchase
 * failures (e.g. wrong product ID sent to the App/Play Store) can be diagnosed remotely.
 * Never throws — a logging failure must not affect the purchase flow.
 */
export async function logIapDebugEvent(
  event: 'requested' | 'result',
  data: Record<string, unknown>,
): Promise<void> {
  try {
    const ref = collection(db, 'iapDebugLogs');
    await addDoc(ref, {
      event,
      ...data,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      createdAt: Timestamp.now(),
      expiresAt: Timestamp.fromMillis(Date.now() + LOG_TTL_MS),
    });
  } catch (error) {
    console.error('Error logging IAP debug event:', error);
  }
}
